module.exports = __webpack_public_path__ + "static/media/idea.f717567b.svg";